import httpClient from './httpClient'

const CampaignApi = {
  async search({
    advertiserId,
    includeDeleted = null,
    insertionOrder,
    campaign,
    keyword = '',
    menuType = null,
    campaignStatuses = ['active', 'inactive'],
    pageNo,
    pageSize,
    sortKey = 'id',
    sortDirection = 'desc',
  }) {
    if (campaignStatuses.length === 0) return { items: [], count: 0, pageNo: 1 }
    const status = (() => {
      if (
        campaignStatuses.includes('active') &&
        campaignStatuses.includes('inactive')
      )
        return undefined
      if (
        campaignStatuses.includes('active') ||
        campaignStatuses.includes('inactive')
      )
        return campaignStatuses[0]
      return undefined
    })()
    const reqBody = {
      query: {
        advertiserId: Number(advertiserId),
        includeDeleted,
        insertionOrder,
        campaign,
        keyword,
        menuType,
        status,
      },
      sortKey,
      sortDirection,
    }
    try {
      if (pageSize === undefined && pageNo === undefined) {
        const res = await httpClient.post('/campaign/search/all', {
          ...reqBody,
        })
        return res.data
      }
      const res = await httpClient.post('/campaign/search', {
        ...reqBody,
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async get(campaignId) {
    try {
      const res = await httpClient.get(`/campaign/${campaignId}`)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async create(body) {
    try {
      const res = await httpClient.post('/campaign', body)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async update(id, body) {
    try {
      const res = await httpClient.put(`/campaign/${id}`, body)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async delete(campaignId) {
    try {
      await httpClient.delete(`/campaign/${campaignId}`)
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async changeStatus(campaignId, changeTo) {
    try {
      const res = await httpClient.put(`/campaign/${campaignId}/changeStatus`, {
        status: changeTo,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default CampaignApi
